module.exports = __webpack_public_path__ + "img/btn_go_2021.6d1db565.png";